import React from "react";
import {LazyLoadImage} from "react-lazy-load-image-component";
import './styles.css';

const LogoSpinner = ({ ...rest}) => (
    <div className={"loader-container"}>
        <LazyLoadImage
            className="center loaderImg"
            threshold={150}
            src={process.env.CDN_URL + "/images/adoptaunanimal/icon/LOGO_ADOPTA_nombre_130x149.webp"}
        />
        <div id="Spinner" className="center"></div>
    </div>
);

export default LogoSpinner;
